import React, { useEffect, useState } from "react";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import i18next from "i18next";
import { Dropdown } from "hesus-ui-kit";
import axios from "axios";
import {
  getDatePickerFormat,
  getDateFormat,
  getCalendarLocale,
} from "@utils/datePickerUtils";
import * as moment from "moment";
import DatePicker from "react-multi-date-picker";
import Header from "./components/Header";
import ListingData from "./components/ListingData";
import PaginationData from "@shared/baseUI/PaginationData/PaginationData";
import AddEditDispute from "../AddEditDispute/AddEditDispute";
import {
  DisputeListContainer,
  OuterWrapper,
  FlexRow,
  SectionContainer,
  FilterFlexRow,
  FilterOuter,
  DisputeServiceInfo,
  GridRow,
  HeaderWrapperTable,
  ButtonWrapper,
  ActionOuter,
} from "./DisputeList.styled";
import "./DisputeList.scss";
import { ColumnButton, labelStyles } from "@utils/extra-style";
import UserInfo from "@utils/UserInfo";

/**
 * Quote List,
 * Path - /qotes
 * @see See [Enquiry Requirements](https://hesusstore.atlassian.net/wiki/spaces/HS/pages/2979135489/Site+-+Quotes)
 * @component
 */
const DisputeList = (props) => {
  const { t, page, entityId, platformCountryId } = props;

  const userDetails = UserInfo.getUser();

  const [isLoading, setIsLoading] = useState(false);
  const [disputeData, setDisputeData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageStart, setPageStart] = useState(0);
  const [pageSize, setPageSize] = useState(page === "main" ? 50 : 20);
  const [pageCount, setPageCount] = useState(0);
  const [isRefreshList, setIsRefreshList] = useState(false);
  const [editDispute, setEditDispute] = useState(false);
  const [isTechAdmin, setIsTechAdmin] = useState(userDetails.techAdmin);
  const [disputeId, setDisputeId] = useState("");
  const [siteId, setSiteId] = useState("");
  const [planningId, setPlanningId] = useState("");
  const [countryId, setCountryId] = useState(platformCountryId);
  const countryList = UserInfo.countryListForFilter(t);
  const [isAddDisputePopupVisible, setAddDisputePopupVisible] = useState(false);

  const [startDate, setStartDate] = useState(
    moment(new Date(new Date().getFullYear(), 0, 1)).format("YYYY-MM-DD")
  );
  const [endDate, setEndDate] = useState(
    moment(new Date()).format("YYYY-MM-DD")
  );
  const onStartDateChange = (e) => {
    setStartDate(moment(e.toDate()).format("YYYY-MM-DD"));
  };

  const onEndDateChange = (e) => {
    setEndDate(moment(e.toDate()).format("YYYY-MM-DD"));
  };

  const fetchGlobalPlanning = () => {
    if (startDate && endDate && countryId) {
      setIsLoading(true);
      let url = `/disputes?fromDate=${moment(startDate).format(
        "YYYY-MM-DD"
      )}&toDate=${moment(endDate).format(
        "YYYY-MM-DD"
      )}&limit=${pageSize}&page=${currentPage}&countries=[${countryId}]`;

      if (page === "main") {
        url = `${url}`;
      } else if (page === "site") {
        url = `${url}&siteId=${entityId}`;
      }

      axios
        .get(url)
        .then((response) => {
          if (response?.data?.disputes?.length > 0) {
            setDisputeData(response.data.disputes);
            setPageCount(response.data.filteredRecords);
          } else {
            setDisputeData([]);
            setPageCount(0);
          }
          setIsLoading(false);
          setIsRefresh(false);
        })
        .catch((error) => {});
    }
  };

  useEffect(() => {
    if (countryId && startDate && endDate) {
      fetchGlobalPlanning(countryId, startDate, endDate);
    }
  }, [startDate, countryId, endDate, currentPage, pageSize, pageStart]);

  const updateDisputeRefeshStatus = () => {
    setIsRefreshList(true);
  };
  useEffect(() => {
    if (isRefreshList) {
      fetchGlobalPlanning(countryId, startDate, endDate);
      setIsRefreshList(false);
    }
  }, [isRefreshList]);

  const createNewDispute = () => {
    setDisputeId("");
    setSiteId("");
    setPlanningId("");
    setEditDispute(false);
    setAddDisputePopupVisible(true);
  };

  const onDisputeEdit = (id, suppliersPlanningLineId, jobsiteId) => {
    setDisputeId(id);
    setSiteId(jobsiteId);
    setPlanningId(suppliersPlanningLineId);
    setEditDispute(true);
    setAddDisputePopupVisible(true);
  };

  const closeDisputeCreationPopup = () => {
    setAddDisputePopupVisible(false);
    setDisputeId("");
    setSiteId("");
    setPlanningId("");
    setEditDispute(false);
  };
  const onCountryChange = (e) => {
    setCountryId(e.value);
  };

  return (
    <DisputeListContainer className="dispute-list">
      <OuterWrapper>
        <FlexRow>
          <SectionContainer>
            <div>
              <FilterFlexRow>
                <FilterOuter>
                  {page === "main" &&
                    isTechAdmin &&
                    countryList?.length > 1 && (
                      <Dropdown
                        id="product-country"
                        label={t("GLOBAL_DISPUTES_FILTER_COUNTRY")}
                        name="country"
                        value={countryId}
                        onChange={onCountryChange}
                        defaultOption={t("COUNTRY")}
                        options={countryList}
                        labelStyles={labelStyles}
                      />
                    )}
                  <div className="dispute-list__dispute-date-container">
                    <label htmlFor="dispute-startdate">
                      {t("GLOBAL_DISPUTES_FILTER_FROM_DATE")}
                    </label>

                    <DatePicker
                      inputClass="dispute-list__dispute-date-input"
                      containerClassName="dispute-list__dispute-datepicker-container"
                      calendarPosition="bottom-center"
                      onChange={onStartDateChange}
                      format={getDatePickerFormat()}
                      locale={getCalendarLocale()}
                      value={getDateFormat(startDate, "YYYY-MM-DD") || ""}
                      name="dispute-startdate"
                    />
                  </div>
                  <div className="dispute-list__dispute-date-container">
                    <label htmlFor="dispute-enddate">
                      {t("GLOBAL_DISPUTES_FILTER_TO_DATE")}
                    </label>

                    <DatePicker
                      inputClass="dispute-list__dispute-date-input"
                      containerClassName="dispute-list__dispute-datepicker-container"
                      calendarPosition="bottom-center"
                      onChange={onEndDateChange}
                      format={getDatePickerFormat()}
                      locale={getCalendarLocale()}
                      value={getDateFormat(endDate, "YYYY-MM-DD") || ""}
                      name="dispute-enddate"
                    />
                  </div>
                </FilterOuter>
                <ActionOuter>
                  {page === "site" && (
                    <ButtonWrapper>
                      <ColumnButton
                        border="#1bace4"
                        background="#1bace4"
                        padding="10px"
                        onClick={() => createNewDispute()}
                      >
                        {t("SITE_DISPUTES_ACTION_NEW")}
                      </ColumnButton>
                    </ButtonWrapper>
                  )}
                </ActionOuter>
              </FilterFlexRow>
            </div>
            <DisputeServiceInfo>
              <Header page={page} />
            </DisputeServiceInfo>
            <DisputeServiceInfo>
              <GridRow marginBottom="0px" gap="0rem">
                <HeaderWrapperTable>
                  <ListingData
                    isLoading={isLoading}
                    disputeData={disputeData}
                    page={page}
                    onDisputeEdit={onDisputeEdit}
                  />
                </HeaderWrapperTable>
              </GridRow>
            </DisputeServiceInfo>
          </SectionContainer>
        </FlexRow>
        {disputeData.length !== 0 && pageCount > 10 && (
          <PaginationData
            pageCount={parseInt(pageCount, 10)}
            pageSize={pageSize}
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
            pageStart={pageStart}
            setPageStart={setPageStart}
            setPageSize={setPageSize}
          />
        )}
      </OuterWrapper>
      {isAddDisputePopupVisible && (
        <AddEditDispute
          id={disputeId}
          isEditMode={editDispute}
          siteId={page === "site" ? entityId : siteId}
          planningId={planningId}
          onClose={closeDisputeCreationPopup}
          updateDisputeRefeshStatus={updateDisputeRefeshStatus}
        />
      )}
    </DisputeListContainer>
  );
};

DisputeList.propTypes = {
  t: PropTypes.func.isRequired,
  page: PropTypes.string,
  entityId: PropTypes.number,
};

DisputeList.defaultProps = {
  page: "main",
  entityId: null,
};

export default withTranslation()(DisputeList);
